export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100">
              <i className="ri-mail-send-line text-2xl text-primary-500"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              爆料投稿 · 商务合作
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto">
              如果你有独家爆料线索或希望与我们进行内容合作，欢迎通过以下方式联系。
              我们重视每一条真实线索，所有投稿均严格保密来源信息。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:tips@heiliaorukou.com"
                className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-mail-line"></i>
                发送邮件投稿
              </a>
              <a
                href="mailto:cooperation@heiliaorukou.com"
                className="flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium rounded-lg border border-background-300 hover:bg-background-200 transition-colors duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-briefcase-line"></i>
                商务合作咨询
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}